import { dateHeader, formatCellDate } from '../../../../utils/columns/timeModeCell';
import { DeleteForever, EnhancedEncryption } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { AuthGuard } from '../../../common/AuthGuard';
import { AppPermissions } from '../../../../constants/Permissions';
import { Policy } from '../../../../types/Policy';

const makePolicyColumn = (managePolicyPermissions, onDeleteClick: (policy: Policy) => void) => {
  return [
    {
      id: 'id',
      header: '',
      accessorKey: 'id',
      enableColumnFilter: false,
      sortable: false,
      size: 30,
      cell: ({ row }) => (
        <Tooltip title='Configure roles' disableInteractive>
          <EnhancedEncryption fontSize='small' cursor='pointer' onClick={() => managePolicyPermissions(row.original.id)} />
        </Tooltip>
      ),
    },
    {
      header: 'Name',
      accessorKey: 'name',
      enableColumnFilter: true,
      size: 250,
    },
    {
      header: dateHeader('Created'),
      accessorKey: 'createdDateTime',
      size: 150,
      cell: ({ row, table }) => formatCellDate(table, row.original.createdDateTime),
    },
    {
      header: dateHeader('Modified'),
      accessorKey: 'modifiedDateTime',
      size: 150,
      cell: ({ row, table }) => formatCellDate(table, row.original.modifiedDateTime),
    },
    {
      header: 'Delete Policy',
      accessorKey: 'action',
      headerClassName: 'react-table-header-align-center',
      size: 50,
      cell: ({ row }) => {
        return (
          <>
            <AuthGuard permission={AppPermissions.User.Manage}>
              <Tooltip title={`Delete ${row.original.name}`} placement='right' style={{ cursor: 'pointer' }}>
                <DeleteForever style={{ height: '0.7em' }} color='action' cursor='pointer' onClick={() => onDeleteClick(row.original)} />
              </Tooltip>
            </AuthGuard>
          </>
        );
      },
    },
  ] as Array<any>;
};
export default makePolicyColumn;
